<template>
  <div>
    <div class="indexList" v-show="flag">
      <div class="father_header">
        <div class="upload_header">
          <van-icon name="arrow-left" color="#000" @click="returnLogin" v-if="this.systemType=='1,2'||this.systemType=='2,1'" />
          <div v-else></div>
          <div>选择平台</div>
          <div></div>
        </div>
      </div>
      <div class="upload-all">
        <div class="upload-choice" v-for="(list,index) in lists" :key="index">
          <div class="uploadList">
            <img :src="list.src" alt="" class="uploadImg">
            <span class="listName">{{list.name}}</span>
          </div>
          <input type="file" id="img" @change="getImg($event,index)" accept="image/*" class="imgInput" />
        </div>
      </div>
    </div>
    <recognitionResult v-show="flagChild" @clearData="clearData" @dialogVisibleEvent="showDialog" @showText="showText" :formList="formList">
    </recognitionResult>
    <textConfirmed v-show="textConfirmed" @dialogVisibleEvent="showDialog" @hideText="hideText"></textConfirmed>
  </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios"
import recognitionResult from "../components/textUpload/recognitionResult.vue";
import textConfirmed from "../components/textUpload/textConfirmed.vue";
import { importScanImage } from '@/axios/api'
export default {
  name: 'list',
  components: {
    recognitionResult,
    textConfirmed
  },
  data() {
    return {
      access_token: '24.ddd193fe368099c77e2233678ec2c6e7.2592000.1657419422.282335-25315974',
      items: [],
      lists: [{
        name: '大众点评',
        src: require('../assets/img/public.png'),
      }, {
        name: '天猫',
        src: require('../assets/img/cat.png'),
      }, {
        name: '新氧',
        src: require('../assets/img/new.png'),
      }, {
        name: '微商城',
        src: require('../assets/img/little.png'),
      },
      {
        name: '更美',
        src: require('../assets/img/more.png'),
      },
      {
        name: '悦美',
        src: require('../assets/img/beautiful.png'),
      },
      ],
      flag: true,
      flagChild: false,
      formList: {},
      textConfirmed: false,
      wordStr: '',
      systemType: ""
    }
  },
  created() {
    this.systemType = JSON.parse(localStorage.getItem('userInfo')).systemType
    console.log(this.systemType)
  },
  methods: {
    returnLogin() {
      this.$router.push("/system");
    },
    // 监听图片选择事件
    getImg(event, index) {
      console.log('input上传图片事件触发')
      console.log(event)
      var that = this
      var imageBase = "";
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      var size = event.target.files[0].size / 1024;
      if (size > 1000) {
        this.compress(event.target.files[0], function (imgBase64) {
          imageBase = imgBase64;
          imageBase = imgBase64.replace("data:image/png;base64,", "");
          console.log('压缩')
          // that.$toast.fail("压缩");
          that.uploadImg(imageBase, index)
        })
      } else {
        reader.onload = function (e) {
          imageBase = e.target.result.replace("data:image/png;base64,", "");
          console.log('无压缩')
          that.uploadImg(imageBase, index)
        }
      }
    },
    uploadImg(imageBase, index) {
      var that = this
      var formData = new FormData();
      formData.append("access_token", that.access_token)
      formData.append("id_card_side", "front")
      formData.append("image", imageBase)
      // https://aip.baidubce.com/rest/2.0/ocr/v1/accurate_basic
      axios.post("https://aip.baidubce.com/rest/2.0/ocr/v1/accurate_basic", formData, {
        header: {
          "Content-Type": "application/x-www-form-urlencoded/",
          "content-type": "application/json"
        },
      }).then((data) => {
        console.log("解析成功");
        // this.$toast.fail("请求解析成功");
        this.items = data.data.words_result
        this.formList = {
          imageBase: []
        }
        this.wordStr = that.items.map((obj) => {
          return "'" + obj.words + "'"
        }).toString()
        console.log(this.wordStr)
        console.log(index)
        this.flag = false
        this.flagChild = true
        this.textConfirmed = false
        if (imageBase.search("base64,") != -1) {
          this.formList.imageBase.push(imageBase)
        } else {
          this.formList.imageBase.push("data:image/png;base64," + imageBase)
        }
        // console.log(this.formList.imageBase)
        // 区分不同平台
        if (index == 0) {
          this.formList.bussinessChannel = '大众点评'
          this.items.forEach(ele => {
            if (ele.words.search("订单编号") != -1) {
              this.formList.orderNo = ele.words.replace(/[^0-9]/ig, '')
            } else if (ele.words.search("丁单编号") != -1) {
              this.formList.orderNo = ele.words.replace(/[^0-9]/ig, '')
            }
            if (ele.words.search("券号：") != -1) {
              this.formList.verificatioCode = ele.words.replace(/[^0-9]/ig, '')
            }
          });
          if (this.wordStr.search("您的恢复") != -1) {
            this.formList.platName = this.wordStr.split(/您的恢复(\S*)/)[0].split(',').slice(-1).toString().replace(
              /\'/g, "");
          }
          if (this.wordStr.search("商品总价") != -1) {
            this.formList.allPrice = this.wordStr.match(/商品总价(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("商家立减") != -1) {
            this.formList.businessReduce = this.wordStr.match(/商家立减(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("平台立减") != -1) {
            this.formList.platformReduce = this.wordStr.match(/平台立减(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("平台抵用券") != -1) {
            this.formList.voucher = this.wordStr.match(/平台抵用券(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("优惠金额") != -1) {
            this.formList.discount = this.wordStr.match(/优惠金额(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("订单总价") != -1) {
            this.formList.orderPrice = this.wordStr.match(/订单总价(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          } else if (this.wordStr.search("丁单总价") != -1) {
            this.formList.orderPrice = this.wordStr.match(/丁单总价(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("实际付款") != -1) {
            this.formList.actualPrice = this.wordStr.match(/实际付款(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          } else if (this.wordStr.search("实示付次") != -1) {
            this.formList.actualPrice = this.wordStr.match(/实示付次(\S*)/)[1].split(',')[0].match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("预定金") != -1) {
            this.formList.advancePayment = this.wordStr.match(/预定金(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          } else if (this.wordStr.search("预付款") != -1) {
            this.formList.advancePayment = this.wordStr.match(/预付款(\S*)/)[1].split(',')[0].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("尾款") != -1) {
            this.formList.balancePayment = this.wordStr.match(/尾款(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("可使用") != -1) {
            if (parseInt(this.wordStr.match(/可使用(\S*)/)[0].split(',')[0].match(/\(([^)]*)\)/)[1].replace(
              /[^0-9]/ig, '')) > 1) {
              this.formList.cardName = '是'
              this.formList.isSecondary = 1
            } else {
              // console.log('没有次数11111')
              this.formList.cardName = '否'
              this.formList.isSecondary = 0
            }
          } else {
            // console.log('没有次数222222')
            this.formList.cardName = '否'
            this.formList.isSecondary = 0
          }
        } else if (index == 1) {
          this.formList.bussinessChannel = '天猫'
        } else if (index == 2) {
          this.formList.bussinessChannel = '新氧'
          if (this.wordStr.search("订单编号") != -1) {
            this.formList.orderNo = this.wordStr.match(/订单编号(\S*)/)[1].split(',')[1].replace(/\'/g, "")
              .replace(
                /[^0-9]/ig, '');
          }
          if (this.wordStr.search("预约码") != -1) {
            this.formList.cppointmentCode = this.wordStr.match(/预约码(\S*)/)[1].split(',')[0].replace(/[^0-9]/ig, '')
          }
          if (this.wordStr.search("订单总金额") != -1) {
            this.formList.businessReduce = this.wordStr.match(/订单总金额(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("实付预约金") != -1) {
            this.formList.platformReduce = this.wordStr.match(/实付预约金(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("剩余应付（尾款）到院再付") != -1) {
            this.formList.voucher = this.wordStr.match(/剩余应付（尾款）到院再付(\S*)/)[1].split(',')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
          if (this.wordStr.search("本单实付金额") != -1) {
            this.formList.orderPrice = this.wordStr.match(/本单实付金额(\S*)/)[1].split(':')[1].replace(/\'/g, "").match(/\d+(\.\d+)?/g).toString();
          }
        } else if (index == 3) {
          this.formList.bussinessChannel = '微商城'
        } else if (index == 4) {
          this.formList.bussinessChannel = '更美'
        } else if (index == 5) {
          this.formList.bussinessChannel = '悦美'
        }
        let userId = JSON.parse(localStorage.getItem('userInfo')).empId
        var data = {
          useId: userId,
          imageData: this.wordStr,
        }
        importScanImage(data)
          .then((res) => {
            console.log('提交识别信息');
            console.log(res.result);
          })
          .catch((err) => {
            console.log(err)
            this.$toast.clear();
          })
      }).catch((err) => {
        console.log("请求解析失败");
        console.log(err);
        this.$toast.fail(err);
      })
    },
    compress(fileObj, callback) {
      console.log('开始压缩')
      if (typeof (FileReader) === 'undefined') {
        console.log("当前浏览器内核不支持base64图片压缩")
        this.$toast.fail("当前浏览器内核不支持base64图片压缩");
        directTurnIntoBase64(fileObj, callback);
      } else {
        try {
          var reader = new FileReader();
          reader.onload = function (e) {
            var image = $('<img/>');
            image.on('load', function () {
              // image.load(function () {
              var squareW = 1000, //定义画布大小,也就是图片压缩之后的像素
                squareH = 1000,
                canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 0, //压缩图片大小
                imageHeight = 0,
                offsetX = 0,
                offsetY = 0,
                data = '';
              canvas.width = squareW;
              canvas.height = squareH;
              context.clearRect(0, 0, squareW, squareH);

              if (this.width > squareW) {
                imageWidth = Math.round(squareW);
                imageHeight = squareH;
                offsetX = Math.round((imageWidth - squareW) / 2);
              } else {
                imageHeight = Math.round(squareH);
                imageWidth = squareW;
                offsetY = Math.round((imageHeight - squareH) / 2)
              }
              // console.log('offsetY')
              // console.log(offsetY)
              context.drawImage(this, offsetX, offsetY, imageWidth, imageHeight);
              var data = canvas.toDataURL('image/jpeg')
              callback(data)
              // console.log(data)
            });
            image.attr('src', e.target.result)
            // console.log(e.target.result)
          };
          reader.readAsDataURL(fileObj);
        } catch (e) {
          console.log('压缩失败!')
          this.$toast.fail("压缩失败!");
          //调用不压缩方法
          directTurnIntoBase64(fileObj, callback)
        }
      }
    },
    showDialog() {
      this.flag = true
      this.flagChild = false
      this.textConfirmed = false
    },
    showText() {
      this.flag = false
      this.flagChild = false
      this.textConfirmed = true
    },
    hideText() {
      this.flag = false
      this.flagChild = true
      this.textConfirmed = false
    },
    clearData() {
      this.formList = ''
    }
  },
};

</script>
<style>
.indexList {
  background: #f5f5f5;
}

#showImg {
  border: 1px solid #000;
}

.inputClass {
  font-size: 2rem;
  border: 1px solid #000;
  width: 200px;
  height: 200px;
  position: relative;
}

.uploadFile {
  display: flex;
  /* flex-direction: column; */
}

.upload_header {
  width: 90%;
  height: 5rem;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #393939;
  line-height: 28px;
  letter-spacing: 1px;
  line-height: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}
.father_header {
  width: 100%;
  background: #fff;
}
.upload-choice {
  width: 10.43rem;
  height: 10.43rem;
  margin: 0.4rem 0.4rem;
  background: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-all {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.listName {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 40px;
  letter-spacing: 1px;
}

.imgInput {
  opacity: 0;
  width: 10.43rem;
  height: 10.43rem;
  border: 1px solid blue;
  position: absolute;
  left: 0;
}

.uploadImg {
  width: 4rem;
}

.uploadList {
  /* border: 1px solid red; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue